/**
 * Møbelglede PDP Premium Interactions
 * Lightweight vanilla JS — IntersectionObserver only, no loops
 * Deferred loading, ~1KB uncompressed
 */
(function() {
  'use strict';

  /* --- Section reveal on scroll --- */
  var revealEls = document.querySelectorAll(
    '.product__accordion, .icon-with-text, .trust-grid, .product-recommendations, .contact'
  );

  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function(el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(10px)';
      el.style.transition = 'opacity 0.45s ease ' + (i * 0.04) + 's, transform 0.45s ease ' + (i * 0.04) + 's';
      revealObs.observe(el);
    });
  }

  /* --- ATC button: success ripple feedback --- */
  var atcBtn = document.querySelector('.product-form__submit');
  if (atcBtn) {
    atcBtn.addEventListener('click', function(e) {
      var btn = e.currentTarget;
      var circle = document.createElement('span');
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height);
      circle.style.cssText = 'position:absolute;border-radius:50%;background:rgba(255,255,255,0.25);pointer-events:none;'
        + 'width:' + size + 'px;height:' + size + 'px;'
        + 'left:' + (e.clientX - rect.left - size / 2) + 'px;'
        + 'top:' + (e.clientY - rect.top - size / 2) + 'px;'
        + 'transform:scale(0);opacity:1;transition:transform 0.5s ease,opacity 0.5s ease;';
      btn.appendChild(circle);
      requestAnimationFrame(function() {
        circle.style.transform = 'scale(2.5)';
        circle.style.opacity = '0';
      });
      setTimeout(function() { circle.remove(); }, 600);
    });
  }

  /* --- Image gallery: fade on slide change --- */
  var gallery = document.querySelector('.product__media-list');
  if (gallery) {
    var mediaItems = gallery.querySelectorAll('.product__media-item');
    if (mediaItems.length > 1 && 'IntersectionObserver' in window) {
      var slideObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          entry.target.style.opacity = entry.isIntersecting ? '1' : '0.4';
        });
      }, { root: gallery, threshold: 0.6 });
      mediaItems.forEach(function(item) {
        item.style.transition = 'opacity 0.3s ease';
        slideObs.observe(item);
      });
    }
  }

  /* --- Thumbnail active state sync --- */
  var thumbs = document.querySelectorAll('.thumbnail-list__item');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

})();
